import queryString from 'query-string'
import { genericFetchingActionCreator } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

export const newAuditSearch = () => (dispatch) => dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'init'))

export const searchForAudits = ({ auditUnit, fiscalYear, auditType, auditNumber, organizationId, organizationName, auditLocation, activeIndicator }) => {
  let query = queryString.stringify({
    auditUnit, fiscalYear, auditType, auditNumber, organizationId, organizationName, auditLocation, activeIndicator
  })
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'fetching'))
    fetch(`/lgyhub/api/audits?${query}`, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'your audit search')
    }).then((responseJson) => {
      dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'fetched', { list: responseJson }))
    }).catch((error) => {
      console.error('Audit search fetching error: ', error)
    })
  }
}

export const findAuditByAuditNumber = (fullAuditNumber) => {
  let query = queryString.stringify({
    fullAuditNumber
  })
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'fetching'))
    fetch(`/lgyhub/api/audits/fullAuditNumberSearch?${query}`, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'your audit search')
    }).then((responseJson) => {
      dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'fetched', { list: responseJson }))
    }).catch((error) => {
      console.error('Audit search fetching error: ', error)
    })
  }
}

export const getOneAudit = (auditId) => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'fetching'))
    fetch(`/lgyhub/api/audits/${auditId}`, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'fetching this audit')
    }).then((responseJson) => {
      if (responseJson === null) {
        dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'error'))
        throw new Error('Audit not found')
      } else {
        dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'fetched', { audit: responseJson }))
      }
    }).catch((error) => {
      dispatch(genericFetchingActionCreator('AUDIT_SEARCH', 'error'))
      console.error('Audit search fetching error: ', error)
    })
  }
}

export const getActiveAudits = () => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('ACTIVE_AUDITS', 'fetching'))
    fetch(`/lgyhub/api/audits/active`, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'fetching this audit')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        dispatch(genericFetchingActionCreator('ACTIVE_AUDITS', 'error'))
        throw new Error(responseJson.errors[0].message)
      } else {
        dispatch(genericFetchingActionCreator('ACTIVE_AUDITS', 'fetched', { list: responseJson }))
      }
    }).catch((error) => {
      console.error('Audit search fetching error: ', error)
    })
  }
}